import { render, staticRenderFns } from "./RipaUsersGrid.vue?vue&type=template&id=e2d450ee&scoped=true"
import script from "./RipaUsersGrid.vue?vue&type=script&lang=js"
export * from "./RipaUsersGrid.vue?vue&type=script&lang=js"
import style0 from "./RipaUsersGrid.vue?vue&type=style&index=0&id=e2d450ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d450ee",
  null
  
)

export default component.exports